import AddBusinessPage from '@features/onboarding/AddBusinessPage';
import AddBusinessStepTitle from '@features/onboarding/AddBusinessStepTitle';
import ChoosePlanPage from '@features/onboarding/ChoosePlanPage';
import ChoosePlanStepTitle from '@features/onboarding/ChoosePlanStepTitle';
import KycPage from '@features/onboarding/KycPage';
import type { ReactNode } from 'react';

interface StepPrerequisiteStore {
  hasSelectedOrg: boolean;
  hasSelectedPlan: boolean;
}

interface Step {
  key: string;
  title: ReactNode;
  path: string;
  component?: ReactNode;
}

export const STEP_PREREQUISITES: Record<string, (store: StepPrerequisiteStore) => boolean> = {
  'add-business': () => true,
  'choose-plan': (store) => store.hasSelectedOrg,
  'complete-kyc': (store) => store.hasSelectedOrg && store.hasSelectedPlan,
};

export const getNextStepPath = (currentStepKey: string) => {
  const currentIndex = ONBOARDING_STEPS.findIndex((s) => s.key === currentStepKey);
  const nextStep = ONBOARDING_STEPS[currentIndex + 1];

  return nextStep?.path;
};

export const ONBOARDING_STEPS: Step[] = [
  {
    key: 'add-business',
    title: <AddBusinessStepTitle />,
    path: '/onboarding/1',
    component: <AddBusinessPage getNextStepPath={() => getNextStepPath('add-business')} />,
  },
  {
    key: 'choose-plan',
    title: <ChoosePlanStepTitle />,
    path: '/onboarding/2',
    component: <ChoosePlanPage getNextStepPath={() => getNextStepPath('choose-plan')} />,
  },
  {
    key: 'complete-kyc',
    title: 'Complete KYC',
    path: '/onboarding/3',
    component: <KycPage />,
  },
];
